import { createContext } from 'react';

const LocalizationContext = createContext({
  isRTL: false,
});

export default LocalizationContext;
